import makePurpose from "./make_purpose";

export default makePurpose(true);
